var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.5625C0 2.94 2.94 0 6.5625 0H53.4375C57.06 0 60 2.94 60 6.5625V38.4375C60 40.178 59.3086 41.8472 58.0779 43.0779C56.8472 44.3086 55.178 45 53.4375 45H6.5625C4.82202 45 3.15282 44.3086 1.92211 43.0779C0.691404 41.8472 0 40.178 0 38.4375L0 6.5625ZM6.5625 5.625C6.31386 5.625 6.0754 5.72377 5.89959 5.89959C5.72377 6.0754 5.625 6.31386 5.625 6.5625V38.4375C5.625 38.955 6.045 39.375 6.5625 39.375H53.4375C53.6861 39.375 53.9246 39.2762 54.1004 39.1004C54.2762 38.9246 54.375 38.6861 54.375 38.4375V6.5625C54.375 6.31386 54.2762 6.0754 54.1004 5.89959C53.9246 5.72377 53.6861 5.625 53.4375 5.625H6.5625Z",
    fill: "#018C0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31.155V13.8484C23.9995 13.6984 24.0386 13.551 24.1134 13.4212C24.1881 13.2915 24.2958 13.1841 24.4254 13.1101C24.5549 13.0361 24.7017 12.9981 24.8507 13.0001C24.9996 13.002 25.1454 13.0439 25.273 13.1213L39.5944 21.7762C39.7182 21.8515 39.8206 21.9577 39.8916 22.0845C39.9627 22.2113 40 22.3544 40 22.5C40 22.6456 39.9627 22.7887 39.8916 22.9155C39.8206 23.0423 39.7182 23.1485 39.5944 23.2238L25.273 31.8787C25.1456 31.956 25.0002 31.9978 24.8515 31.9999C24.7028 32.002 24.5563 31.9643 24.4268 31.8907C24.2974 31.8171 24.1896 31.7102 24.1146 31.5809C24.0397 31.4517 24.0001 31.3047 24 31.155Z",
    fill: "#018C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdu);
export default __webpack_public_path__ + "static/media/edu.9cda3307beac4fca9e7b6e23fdbbe309.svg";
export { ForwardRef as ReactComponent };